module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABbElEQVRYR+3XPS8FQRjF8Z8gGhoFeolI6AVR+QxaQq1QiC+gVCmUGlqll0ojopYgGo2OREmEeMskbrK5udyd3b3Y2Ol29zlnzv5nM/tMmz8+2v54PlXAvCtUOoK9mMdA3jfPqH/BMfZq+iTBLpxiOKN5kbJFbATDZMBxnBQ5Sw6vkGOyPuAgLtGZw7go6Q5m6gOG61GMISz3b4x33OEA940C/kaob+cs3TZTEYwlUC1xLLH6+lISHPrBf/EzzvDwFel6gptYyLsskfpbTOOikS4ZcATnkeZFlW9jtlnAHlyhr6hZI3yWsN4sYHgeKC6jP8I8T2n4Bg8/W6u3NAHzTNYSbSm3mZaQyGpaEcxKrqarCP47guEktdrCZuERuwjn3qc0dJPfYPh7XP/QiW4Fa7EBp3CURlRAzRbm0vgkCXZjHxNoTyPOWHPz2dKFs2/T0WibCfc6miqzFYSG4DVGWu2DMbSqdisvrVIS/ADDwigp2tCQLgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-menu.png
// module id = uwUW
// module chunks = 1